import React, { FC } from 'react';
import { Asset, HelpIcon, Tooltip, TooltipProps } from '@clearcover/atlas';
import styles from './styles.module.css';

type InfoTooltipPropsType = {
  tooltip: TooltipProps['tooltip'];
  position?: TooltipProps['position'];
  className?: TooltipProps['className'];
  size?: number;
  tooltipLabel?: React.ReactNode;
};

export const InfoTooltip: FC<InfoTooltipPropsType> = ({
  tooltip,
  position,
  className,
  tooltipLabel,
  size = 18,
}) => {
  return (
    <Tooltip className={className} tooltip={tooltip} position={position}>
      <div className={className}>
        {tooltipLabel}
        <Asset
          className={styles.tooltipIcon}
          icon={HelpIcon}
          height={size}
          width={size}
          description="tooltip"
        />
      </div>
    </Tooltip>
  );
};
